// 分页查询BD下游账户列表
export const getBdDownStreamAccountList = function (params) {
  return this.$http('get', 'mall/bdDownStreamAccount/page', params);
}

// 添加成员
export const saveAccount = function (data) {
  return this.$http('post', 'mall/bdDownStreamAccount/save', data);
}
// 修改
export const editAccount = function (data) {
  return this.$http('post', 'mall/bdDownStreamAccount/update', data);
}

export const updateStatus = function (data = {}) {
  const { id, status } = data
  return this.$http('post', `mall/bdDownStreamAccount/updateStatus?id=${id}&status=${status}`);
}
// 历史
export const getChannelDeductionHistory = function (data) {
  return this.$http('get', 'mall/bdDownStreamAccount/channelDeductionHistory', data);
}